import { AvatarList, TableBodyCell, UserAvatar } from '@pocketlaw/tetris';
import { EmptyCell } from './EmptyCell';
export function ContractOwnerCell(props) {
    const { headers, owners } = props;
    if (!owners.length) {
        return <EmptyCell headers={headers}/>;
    }
    return (<TableBodyCell headers={headers}>
      <AvatarList>
        {owners.map((owner) => (<UserAvatar key={owner.id} title={owner.name}/>))}
      </AvatarList>
    </TableBodyCell>);
}
